import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleAxiosError } from "../serviceUtils/handleAxiosError";

const createServiceAsyncThunk = <ReturnType, ArgsType>(
  typePrefix: string,
  serviceCall: (args: ArgsType) => Promise<ReturnType>,
  errorMessage: string
) =>
  createAsyncThunk<
    ReturnType,
    ArgsType,
    { rejectValue: { status?: number; message: string } }
  >(typePrefix, async (args, { rejectWithValue }) => {
    try {
      return await serviceCall(args);
    } catch (error) {
      return rejectWithValue(handleAxiosError(error, errorMessage));
    }
  });

export default createServiceAsyncThunk;
